import { jsx, jsxs } from "react/jsx-runtime";
import { styled } from "@linaria/react";
import * as React from "react";
import { forwardRef } from "react";
import { typographyClassName } from "@creditornot/cb-ingredients";
import { createCssVars, assignInlineCssVars, clsx } from "@creditornot/cb-utils";
import "./style.css";
const SvgCross = forwardRef((props, ref) => /* @__PURE__ */ jsx("svg", { viewBox: "0 0 24 24", ...props, ref, children: /* @__PURE__ */ jsx("path", { d: "M2.44 19.44a1.5 1.5 0 002.121 2.121l7.262-7.26a.25.25 0 01.354 0l7.262 7.262a1.5 1.5 0 102.122-2.12l-7.26-7.266a.25.25 0 010-.354l7.262-7.262a1.5 1.5 0 00-2.124-2.12L12.177 9.7a.25.25 0 01-.354 0L4.561 2.44A1.5 1.5 0 002.44 4.56L9.7 11.823a.25.25 0 010 .354L2.44 19.44z" }) }));
const CrossIcon = SvgCross;
createCssVars(["bg", "bgHover", "bgActive", "iconFill", "iconFillHover", "iconFillDisabled", "focusOutline"]);
const sizeCssVars = createCssVars(["iconSize"]);
const BG = /* @__PURE__ */ styled("div")({
  name: "BG",
  class: "cb_TagRemoveButton_BG_bg5w",
  propsAsIs: false
});
const IconContainer$1 = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_TagRemoveButton_IconContainer_ikr0",
  propsAsIs: false
});
const Root$1 = /* @__PURE__ */ styled("button")({
  name: "Root",
  class: "cb_TagRemoveButton_Root_r124",
  propsAsIs: false
});
const TagRemoveButton = ({
  children: icon,
  iconSize,
  style,
  ...rest
}) => /* @__PURE__ */ jsxs(Root$1, {
  style: {
    ...style,
    ...assignInlineCssVars(sizeCssVars, {
      iconSize
    })
  },
  ...rest,
  type: "button",
  children: [/* @__PURE__ */ jsx(BG, {}), /* @__PURE__ */ jsx(IconContainer$1, {
    children: icon
  })]
});
const _exp = () => ({
  $position
}) => $position === "start" ? 4 : 0;
const _exp2 = () => ({
  $position
}) => $position === "end" ? 4 : 0;
const IconContainer = /* @__PURE__ */ styled("div")({
  name: "IconContainer",
  class: "cb_Tag_IconContainer_i9s6",
  propsAsIs: false,
  vars: {
    "i9s6r71-0": [_exp(), "px"],
    "i9s6r71-1": [_exp2(), "px"]
  }
});
const Root = /* @__PURE__ */ styled("div")({
  name: "Root",
  class: "cb_Tag_Root_r1qi",
  propsAsIs: false
});
const Label = /* @__PURE__ */ styled("div")({
  name: "Label",
  class: "cb_Tag_Label_lmag",
  propsAsIs: false
});
const RemoveButtonContainer = /* @__PURE__ */ styled("div")({
  name: "RemoveButtonContainer",
  class: "cb_Tag_RemoveButtonContainer_r5bz",
  propsAsIs: false
});
const iconProps = {
  // Icon "does not matter" if it's decorative
  // https://css-tricks.com/accessible-svg-icons/
  "aria-hidden": true,
  role: "img",
  focusable: false
};
const Tag = React.forwardRef(({
  children,
  icon,
  iconPosition = "start",
  onRemoveClick,
  removeButtonAriaLabel,
  removeButtonProps = {},
  removeDisabled,
  size = "small",
  uppercase = false,
  variant = "blue",
  ...rest
}, ref) => {
  const iconContainer = icon ? /* @__PURE__ */ jsx(IconContainer, {
    $position: iconPosition,
    children: React.isValidElement(icon) ? React.cloneElement(icon, iconProps) : React.createElement(icon, iconProps)
  }) : void 0;
  return /* @__PURE__ */ jsxs(Root, {
    "data-size": size,
    "data-variant": variant,
    ref,
    ...rest,
    children: [iconPosition === "start" && iconContainer, /* @__PURE__ */ jsx(Label, {
      className: clsx({
        [typographyClassName.TinySemiBold]: size === "tiny" && !uppercase,
        [typographyClassName.Overline4]: size === "tiny" && uppercase,
        [typographyClassName.SmallSemiBold]: size === "small" && !uppercase,
        [typographyClassName.Overline3]: size === "small" && uppercase
      }),
      children
    }), iconPosition === "end" && iconContainer, !!(onRemoveClick || removeButtonProps.onClick) && /* @__PURE__ */ jsx(RemoveButtonContainer, {
      "data-variant": variant,
      children: /* @__PURE__ */ jsx(TagRemoveButton, {
        ...removeButtonProps,
        "aria-label": removeButtonAriaLabel || removeButtonProps["aria-label"] || (typeof children === "string" ? `Remove ${children}` : "Remove"),
        disabled: removeDisabled ?? removeButtonProps.disabled,
        iconSize: "var(--removeButtonSize)",
        onClick: onRemoveClick || removeButtonProps.onClick,
        children: /* @__PURE__ */ jsx(CrossIcon, {})
      })
    })]
  });
});
Tag.displayName = "Tag";
export {
  Tag
};
//# sourceMappingURL=index.js.map
